import { Col, Form, InputNumber, Select } from 'antd';


import { repeatServicesTimeUnits } from '../../../../config/constants/incidentsConstants';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

export const FormRepeatAppointments = () => {
  const { translate: t } = useDictionaryTranslation();
  const { Option } = Select;

  return (
    <>
      <Col xs={6}>
        <Form.Item
          label={t('howOften')}
          name="howOften"
          rules={[{ required: true }]}
        >
          <InputNumber placeholder={t('howOftenPlaceholder')} />
        </Form.Item>
      </Col>

      <Col xs={6}>
        <Form.Item
          label={t('timeUnit')}
          name="timeUnit"
          rules={[{ required: true }]}
        >
          <Select placeholder={t('timeUnitPlaceholderPleace')} size="middle" bordered={false}>
            {repeatServicesTimeUnits.map((unit) => (
              <Option size="large" key={unit.value} value={unit.value}>
                {t(unit.label)}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={6}>
        <Form.Item
          label={t('repeatTimes')}
          name="repeatTimes"
          rules={[{ required: true }]}
        >
          <InputNumber placeholder={t('repeatTimesPlaceholder')} />
        </Form.Item>
      </Col>
    </>
  );
};

export default FormRepeatAppointments;
